/**
 * humburger
 */
export function humburger_menu() {
  document.addEventListener('DOMContentLoaded', function() {

    const hamButton = document.getElementById('hamburger-button');
    const humBody   = document.getElementsByTagName('body');
    const hamDrawer = document.getElementById('drawer');

    hamButton.addEventListener('click', function() {
      hamButton.classList.toggle('is-open');
      humBody[0].classList.toggle('is-locked');

      if ( hamButton.getAttribute('aria-expanded') == 'false' ) {
        hamButton.setAttribute('aria-expanded', true);
      } else {
        hamButton.setAttribute('aria-expanded', false);
      }
      if ( hamButton.getAttribute('aria-expanded') == 'true' ) {
        hamDrawer.setAttribute('aria-hidden', false);
      } else {
        hamDrawer.setAttribute('aria-hidden', true);
      }

    }, false);

    /**
     * ドロワーメニュー内のアンカーリンク#を押した時に閉じる
     * drawer > .drawer-navi > li > a:href #
     */
    const humDrawerLink = document.querySelector('.drawer-navi a[href^="/#"]');
    if (!humDrawerLink){
      return false;
    }

    humDrawerLink.addEventListener('click', function() {
      hamButton.classList.remove('is-open');
      humBody[0].classList.remove('is-locked');

      if ( hamButton.getAttribute('aria-expanded') == 'false' ) {
        hamButton.setAttribute('aria-expanded', true);
      } else {
        hamButton.setAttribute('aria-expanded', false);
      }
      if ( hamButton.getAttribute('aria-expanded') == 'true' ) {
        hamDrawer.setAttribute('aria-hidden', false);
      } else {
        hamDrawer.setAttribute('aria-hidden', true);
      }

    }, false);

  });

}

/**
 * ドロワーメニューの開閉
 */
export function drawer_menu() {
  document.addEventListener('DOMContentLoaded', function () {
    const toggleButtons = document.querySelectorAll('.menu-item-has-children .submenu-toggle');

    toggleButtons.forEach(function (btn) {

      const submenu = btn.closest('.menu-item-has-children').querySelector('.sub-menu');
      // 初期化時にmaxHeightを0に設定
      if (submenu) {
        submenu.style.maxHeight = '0';
      }

      btn.addEventListener('click', function (event) {
        event.stopPropagation();
        const parentMenuItem = btn.closest('.menu-item-has-children');
        const submenu = parentMenuItem.querySelector('.sub-menu');

        if (submenu) {
          const isOpen = parentMenuItem.classList.contains('is-open');
          if (!isOpen) {
            // サブメニューを開く
            submenu.style.display = 'block';
            // displayがblockになるまでの遅延を確実にする
            setTimeout(() => {
              submenu.style.maxHeight = submenu.scrollHeight + "px";
            }, 10);
            parentMenuItem.classList.add('is-open');
          } else {
            // サブメニューを閉じる
            submenu.style.maxHeight = '0';
            submenu.style.display = 'block'; // ここでdisplay:blockを設定し、トランジションを確実に開始
            submenu.addEventListener('transitionend', () => {
              // トランジションが完了してからdisplayをnoneに設定
              if (!parentMenuItem.classList.contains('is-open')) {
                submenu.style.display = 'none';
              }
            }, { once: true });
            parentMenuItem.classList.remove('is-open');
          }
        } else {
          console.log('サブメニューがこの要素には存在しません。');
        }
      });
    });
  });
}
